/**
 * The Color — Shared Utilities
 * Common helper functions used across theme JavaScript.
 * Loaded before all other JS files.
 */

(function () {
  'use strict';

  /**
   * Format price in GBP (pence to pounds)
   * @param {number} pence - Price in pence
   * @returns {string} Formatted price string e.g. "£12.50"
   */
  function formatMoney(pence) {
    return '\u00A3' + (pence / 100).toFixed(2);
  }

  /**
   * Escape a string for safe rendering as HTML text content
   * @param {string} text - Raw string
   * @returns {string} HTML-escaped string
   */
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Escape a string for safe use inside HTML attributes
   * @param {string} str - Raw string
   * @returns {string} Attribute-safe string
   */
  function escapeAttr(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /**
   * Check if user accepted analytics cookies (GDPR).
   * Returns true ONLY when tc_cookie_consent === 'accepted'.
   * @returns {boolean}
   */
  function hasConsent() {
    var match = document.cookie.match(/(?:^|; )tc_cookie_consent=([^;]*)/);
    return match ? decodeURIComponent(match[1]) === 'accepted' : false;
  }

  // Expose on global namespace
  window.TheColor = window.TheColor || {};
  window.TheColor.utils = {
    formatMoney: formatMoney,
    escapeHtml: escapeHtml,
    escapeAttr: escapeAttr,
    hasConsent: hasConsent,
  };
})();
